// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-lesson-plans {
    background-color: #ff9900;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
  }

  .manage-lesson-plans h2 {
    color: white;
  }

  .plan-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
  }

  .plan-card {
    background-color: white;
    border-radius: 4px;
    padding: 20px;
    margin-right: 20px;
    margin-bottom: 20px;
    width: 300px;
  }

  .edit-form {
    margin-top: 20px;
  }

  .edit-form input,
  .edit-form textarea {
    display: block;
    margin-bottom: 10px;
    width: 100%;
  }

  .buttonsinz {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }

  .aqua-button1 {
    background-color: rgb(54, 168, 168);
    size: 100px;
  }

  .update-button {
    background-color: lightblue;
    margin-right: 10px;
  }
.upload-section {
  margin: 20px 0;
  padding: 15px;
  background-color: #f5f5f5;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

.inz-upload-button {
  padding: 8px 15px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.inz-upload-button:hover {
  background-color: #45a049;
}

.inz-upload-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/MyComponents/ManageContent/managecontentforms/managecontentstyle/ManageLessonPlans.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,cAAc;IACd,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,mCAAmC;IACnC,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;AACF;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":[".manage-lesson-plans {\n    background-color: #ff9900;\n    padding: 20px;\n    border-radius: 8px;\n    margin-bottom: 20px;\n  }\n\n  .manage-lesson-plans h2 {\n    color: white;\n  }\n\n  .plan-list {\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 20px;\n  }\n\n  .plan-card {\n    background-color: white;\n    border-radius: 4px;\n    padding: 20px;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    width: 300px;\n  }\n\n  .edit-form {\n    margin-top: 20px;\n  }\n\n  .edit-form input,\n  .edit-form textarea {\n    display: block;\n    margin-bottom: 10px;\n    width: 100%;\n  }\n\n  .buttonsinz {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 20px;\n  }\n\n  .aqua-button1 {\n    background-color: rgb(54, 168, 168);\n    size: 100px;\n  }\n\n  .update-button {\n    background-color: lightblue;\n    margin-right: 10px;\n  }\n.upload-section {\n  margin: 20px 0;\n  padding: 15px;\n  background-color: #f5f5f5;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n}\n\n.inz-upload-button {\n  padding: 8px 15px;\n  background-color: #4CAF50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s;\n}\n\n.inz-upload-button:hover {\n  background-color: #45a049;\n}\n\n.inz-upload-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
